module.exports = __webpack_public_path__ + "static/media/power-all5.164d48ba.png";